import { render, staticRenderFns } from "./ChangeTimetable.vue?vue&type=template&id=2d203c98"
import script from "./ChangeTimetable.vue?vue&type=script&lang=js"
export * from "./ChangeTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports